// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IconInput_wrapper__2d0CJ","icon":"IconInput_icon__3_--h","icon-input":"IconInput_icon-input__15kVh","icon-right":"IconInput_icon-right__CwdJr"};